import React from "react";
import { motion } from "framer-motion";

const TextInput = ({
  infoObjectName,
  path,
  name,
  data,
  options,
  rendererOptions: { hideKeys, type },
}) => {
  const inputType = ["text", "number", "url", "datetime-local"].includes(type)
    ? type
    : "text";

  const inputStyle = {
    flex: "0 0 auto",
    padding: "0.25rem 0.5rem",
    borderRadius: "5px",
    border: "1px solid #ccc",
    outline: "none",
    backgroundColor: "inherit",
    fontSize: "0.875rem",
  };

  return (
    <motion.input
      id={name}
      type={inputType}
      defaultValue={data || ""}
      // onChange={(e) => onChange(e.target.value)}
      style={inputStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      data-renderer="text-input"
    />
  );
};

export default TextInput;
